<template>
  <button :class="setClassName" :disabled="disabled" v-on:click="onClick">
    {{ buttonName }}
  </button>
</template>

<script>
export default {
  props: {
    buttonName: String,
    buttonClass: String,
    onClick: Function,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    setClassName: function() {
      return this.buttonClass + " btn";
    }
  }
};
</script>

<style lang="scss" scoped>
.btn {
  padding: 16px 32px;
  width: auto;
  min-width: 200px;
  border: none;
  color: white;
  background-color: #bd1f23;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: #a01a1e;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(189, 31, 35, 0.3);
  }
  
  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 6px rgba(189, 31, 35, 0.2);
  }
  
  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(189, 31, 35, 0.2);
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
    
    &:hover {
      background-color: #bd1f23;
      transform: none;
      box-shadow: none;
    }
  }
}
</style>
